import { MouseEvent } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "chameleon/lib/components";

interface Props {
  isDisabled?: boolean;
  onClickEdit?: (e?: MouseEvent) => void;
}

export const FormEditButton = ({ isDisabled, onClickEdit }: Props) => {
  const { t } = useTranslation(["combined"]);

  return (
    <Button
      id="edit-payment-method-btn"
      variant="text"
      isDisabled={isDisabled}
      text={t("edit")}
      onClick={onClickEdit}
      testId="hpp-btn-edit-payment-form"
    />
  );
};
